import { c as _c } from "react/compiler-runtime";
import { CalculatePriceInterface, PhysicalCheckout, StoreImageEnum } from '@systemeio/digital-store-shared';
import { LanguageCodeEnum, PrimaryButton, cents } from '@systemeio/ui';
import ItemTabs, { ItemTabType } from 'modules/stores/store/components/item-tabs';
import ThankYouTab from 'modules/stores/store/components/tabs/thank-you-tab';
import { STORE_ITEM_CLASS_NAME } from 'modules/stores/store/constants/store-item-class-name';
import Thumbnail from 'modules/stores/store/content/product/components/thumbnail';
import { useStoreEditItemContext } from 'modules/stores/store/context/store-item-edit-context';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { StoreId } from 'modules/stores/types/stores-interface';
import { FC, useEffect, useState } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import { useProduct } from '../../../../../products/hooks/use-products';
import ItemActions from '../../../components/item-actions';
import { useStorePreviewContext } from '../../../context/store-preview-context';
import { PhysicalProductItemEditType, PhysicalProductItemErrorsType, PhysicalProductItemViewType } from '../types/product-interface';
import { PhysicalCheckout as Checkout } from './components/checkout';
import PhysicalProduct from './components/physical-product';
import { defaultErrors } from './constants/default-errors';
import { defaultValues } from './constants/default-values';
import { PhysicalProductTabEnum, tabLocoKeys } from './enum/physical-product-tab-enum';
import { useErrorMessageInTabs } from './hooks/use-error-message-in-tabs';
import { useSavePhysicalProductItem } from './hooks/use-save-physical-product-item';
import { getNextTab } from './utls/get-next-tab-physical-product';
import { useStoreContactFields } from 'modules/stores/store/hooks/use-store-contact-fields';
import { physicalProductInitFields } from './constants/mandatory-fields';
import { PhysicalProductInterface } from '@systemeio/types';
import { toPercent } from '@systemeio/util';
interface Props {
  storeId: StoreId;
  item?: PhysicalProductItemViewType;
  languageCode: LanguageCodeEnum;
}
const Edit: FC<Props> = t0 => {
  const $ = _c(154);
  const {
    storeId,
    item,
    languageCode
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [tab, setTab] = useState(PhysicalProductTabEnum.thumbnail);
  const {
    data: storeView
  } = useStore(storeId);
  let t1;
  if ($[0] !== languageCode || $[1] !== t) {
    t1 = t("dashboard.store.product.physical.title_default", {
      lng: languageCode
    });
    $[0] = languageCode;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== languageCode || $[4] !== t) {
    t2 = t("dashboard.store.product.physical.subtitle_default", {
      lng: languageCode
    });
    $[3] = languageCode;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== languageCode || $[7] !== t) {
    t3 = t("dashboard.store.product.physical.button_default", {
      lng: languageCode
    });
    $[6] = languageCode;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== languageCode || $[10] !== t) {
    t4 = t("dashboard.store.product.checkout.title_default", {
      lng: languageCode
    });
    $[9] = languageCode;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== languageCode || $[13] !== t) {
    t5 = t("dashboard.store.product.physical.checkout.subtitle_default_tip-tap", {
      lng: languageCode
    });
    $[12] = languageCode;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== languageCode || $[16] !== t) {
    t6 = t("dashboard.store.product.checkout.button_default", {
      lng: languageCode
    });
    $[15] = languageCode;
    $[16] = t;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = {
      ...defaultValues.checkoutPage,
      title: t4,
      description: t5,
      buttonTitle: t6
    };
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== languageCode || $[23] !== t) {
    t8 = t("dashboard.store.product.physical.thank_you.title_default", {
      lng: languageCode
    });
    $[22] = languageCode;
    $[23] = t;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== languageCode || $[26] !== t) {
    t9 = t("dashboard.store.product.physical.thank_you.subtitle_default", {
      lng: languageCode
    });
    $[25] = languageCode;
    $[26] = t;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t8 || $[29] !== t9) {
    t10 = {
      title: t8,
      text: t9
    };
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t1 || $[32] !== t10 || $[33] !== t2 || $[34] !== t3 || $[35] !== t7) {
    t11 = {
      ...defaultValues,
      draft: false,
      title: t1,
      subTitle: t2,
      buttonTitle: t3,
      checkoutPage: t7,
      thankYouPage: t10
    };
    $[31] = t1;
    $[32] = t10;
    $[33] = t2;
    $[34] = t3;
    $[35] = t7;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  const defaultValuesWithLoco = t11;
  const [tempState, setTempState] = useState(item || defaultValuesWithLoco);
  const {
    errors: initialErrors,
    setErrors: setEditItemErrors
  } = useStoreEditItemContext();
  let t12;
  if ($[37] !== initialErrors) {
    t12 = {
      ...defaultErrors,
      ...initialErrors
    };
    $[37] = initialErrors;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  const [errors, setErrors] = useState(t12);
  let t13;
  if ($[39] !== setEditItemErrors) {
    t13 = () => () => {
      setEditItemErrors({});
    };
    $[39] = setEditItemErrors;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = [];
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  useEffect(t13, t14);
  let t15;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = fields => setTempState(prev => ({
      ...prev,
      checkoutPage: {
        ...prev.checkoutPage,
        fields
      }
    }));
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== tempState.checkoutPage.fields) {
    t16 = {
      savedFields: tempState.checkoutPage.fields,
      initFields: physicalProductInitFields,
      onChange: t15
    };
    $[43] = tempState.checkoutPage.fields;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  useStoreContactFields(t16);
  const t17 = item?.checkoutPage.physicalProductId;
  let t18;
  if ($[45] !== storeId || $[46] !== t17 || $[47] !== tempState) {
    t18 = {
      tempState,
      setTempState,
      storeId,
      setErrors,
      initialProductId: t17
    };
    $[45] = storeId;
    $[46] = t17;
    $[47] = tempState;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  const {
    onPublish,
    isFetchingPublish,
    isFetchingDraft,
    onSaveDraft
  } = useSavePhysicalProductItem(t18);
  const isNew = !item;
  const inReadyToSave = isNew ? true : !!tempState.checkoutPage.physicalProductId;
  const isPublishAllowed = tab === PhysicalProductTabEnum.thank_you;
  const isCreatingProcess = !item;
  const {
    getTabsWithErrors
  } = useErrorMessageInTabs();
  let t19;
  if ($[49] !== errors || $[50] !== getTabsWithErrors) {
    t19 = getTabsWithErrors({
      errors
    });
    $[49] = errors;
    $[50] = getTabsWithErrors;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  const errorsByTab = t19;
  let t20;
  if ($[52] !== t) {
    t20 = t(tabLocoKeys[PhysicalProductTabEnum.thumbnail]);
    $[52] = t;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  const t21 = errorsByTab[PhysicalProductTabEnum.thumbnail];
  let t22;
  if ($[54] !== t20 || $[55] !== t21) {
    t22 = {
      key: PhysicalProductTabEnum.thumbnail,
      caption: t20,
      hasError: t21
    };
    $[54] = t20;
    $[55] = t21;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== t) {
    t23 = t(tabLocoKeys[PhysicalProductTabEnum.physical_product]);
    $[57] = t;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  const t24 = errorsByTab[PhysicalProductTabEnum.physical_product];
  let t25;
  if ($[59] !== t23 || $[60] !== t24) {
    t25 = {
      key: PhysicalProductTabEnum.physical_product,
      caption: t23,
      hasError: t24
    };
    $[59] = t23;
    $[60] = t24;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t) {
    t26 = t(tabLocoKeys[PhysicalProductTabEnum.checkout]);
    $[62] = t;
    $[63] = t26;
  } else {
    t26 = $[63];
  }
  const t27 = errorsByTab[PhysicalProductTabEnum.checkout];
  let t28;
  if ($[64] !== t26 || $[65] !== t27) {
    t28 = {
      key: PhysicalProductTabEnum.checkout,
      caption: t26,
      hasError: t27
    };
    $[64] = t26;
    $[65] = t27;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== t) {
    t29 = t(tabLocoKeys[PhysicalProductTabEnum.thank_you]);
    $[67] = t;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  const t30 = errorsByTab[PhysicalProductTabEnum.thank_you];
  let t31;
  if ($[69] !== t29 || $[70] !== t30) {
    t31 = {
      key: PhysicalProductTabEnum.thank_you,
      caption: t29,
      hasError: t30
    };
    $[69] = t29;
    $[70] = t30;
    $[71] = t31;
  } else {
    t31 = $[71];
  }
  let t32;
  if ($[72] !== t22 || $[73] !== t25 || $[74] !== t28 || $[75] !== t31) {
    t32 = [t22, t25, t28, t31];
    $[72] = t22;
    $[73] = t25;
    $[74] = t28;
    $[75] = t31;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  const tabs = t32;
  const {
    setPreview,
    setSingleItemMode
  } = useStorePreviewContext();
  const {
    data: physicalProduct
  } = useProduct(tempState.checkoutPage.physicalProductId);
  let t33;
  if ($[77] !== physicalProduct) {
    t33 = !!physicalProduct?.productVariants?.length ? physicalProduct.productVariants[0]?.price ?? cents(0) : physicalProduct?.price ?? cents(0);
    $[77] = physicalProduct;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  const price = t33;
  let t34;
  if ($[79] !== physicalProduct || $[80] !== price) {
    t34 = physicalProduct ? {
      originalAmount: price,
      grossAmount: price,
      pricePlan: physicalProduct.pricePlan.id,
      quantity: 1,
      netAmount: price,
      discountedNetAmount: price,
      tax: {
        amount: cents(0),
        rate: toPercent(0)
      },
      discount: {
        amount: cents(0),
        percent: toPercent(0)
      },
      shippingFee: {
        amount: cents(0),
        tax: {
          amount: cents(0),
          rate: toPercent(0)
        }
      },
      currencyCode: physicalProduct.currency
    } : undefined;
    $[79] = physicalProduct;
    $[80] = price;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  const calculatePrice = t34;
  let t35;
  if ($[82] !== calculatePrice || $[83] !== physicalProduct || $[84] !== setPreview || $[85] !== setSingleItemMode || $[86] !== storeView?.currency || $[87] !== storeView?.paymentMethods || $[88] !== tab || $[89] !== tempState.checkoutPage || $[90] !== tempState.productType || $[91] !== tempState.thankYouPage) {
    t35 = () => {
      if ([PhysicalProductTabEnum.checkout, PhysicalProductTabEnum.physical_product].includes(tab) && physicalProduct) {
        setPreview([<PhysicalCheckout physicalProduct={physicalProduct} calculatePrice={calculatePrice} key="Checkout page preview" checkoutPage={tempState.checkoutPage} paymentMethods={storeView?.paymentMethods} currency={storeView?.currency} thankYouPage={tempState.thankYouPage} productType={tempState.productType} displayAffiliateLink={false} skipDisabledButton={true} />]);
        setSingleItemMode(false);
      }
    };
    $[82] = calculatePrice;
    $[83] = physicalProduct;
    $[84] = setPreview;
    $[85] = setSingleItemMode;
    $[86] = storeView?.currency;
    $[87] = storeView?.paymentMethods;
    $[88] = tab;
    $[89] = tempState.checkoutPage;
    $[90] = tempState.productType;
    $[91] = tempState.thankYouPage;
    $[92] = t35;
  } else {
    t35 = $[92];
  }
  const t36 = storeView?.currency;
  const t37 = storeView?.paymentMethods;
  let t38;
  if ($[93] !== physicalProduct || $[94] !== setPreview || $[95] !== setSingleItemMode || $[96] !== t36 || $[97] !== t37 || $[98] !== tab || $[99] !== tempState) {
    t38 = [t36, t37, setPreview, setSingleItemMode, tempState, physicalProduct, tab];
    $[93] = physicalProduct;
    $[94] = setPreview;
    $[95] = setSingleItemMode;
    $[96] = t36;
    $[97] = t37;
    $[98] = tab;
    $[99] = tempState;
    $[100] = t38;
  } else {
    t38 = $[100];
  }
  useEffect(t35, t38);
  let t39;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = twMerge(STORE_ITEM_CLASS_NAME, "flex flex-col gap-5");
    $[101] = t39;
  } else {
    t39 = $[101];
  }
  let t40;
  if ($[102] !== tab || $[103] !== tabs) {
    t40 = <ItemTabs tabs={tabs} currentTab={tab} setTab={setTab} />;
    $[102] = tab;
    $[103] = tabs;
    $[104] = t40;
  } else {
    t40 = $[104];
  }
  let t41;
  if ($[105] !== errors || $[106] !== tab || $[107] !== tempState) {
    t41 = tab === PhysicalProductTabEnum.thumbnail && <Thumbnail imageType={StoreImageEnum.physical_product_thumbnail} tempState={tempState} setTempState={setTempState} errors={errors} />;
    $[105] = errors;
    $[106] = tab;
    $[107] = tempState;
    $[108] = t41;
  } else {
    t41 = $[108];
  }
  let t42;
  if ($[109] !== errors || $[110] !== tab || $[111] !== tempState) {
    t42 = tab === PhysicalProductTabEnum.checkout && <Checkout tempState={tempState} setTempState={setTempState} errors={errors} imageType={StoreImageEnum.physical_product_cover} />;
    $[109] = errors;
    $[110] = tab;
    $[111] = tempState;
    $[112] = t42;
  } else {
    t42 = $[112];
  }
  let t43;
  if ($[113] !== errors || $[114] !== storeView || $[115] !== tab || $[116] !== tempState) {
    t43 = tab === PhysicalProductTabEnum.physical_product && storeView?.currency && <PhysicalProduct tempState={tempState} setTempState={setTempState} currency={storeView.currency} physicalProductSelectorError={errors["checkoutPage.physicalProductId"]} />;
    $[113] = errors;
    $[114] = storeView;
    $[115] = tab;
    $[116] = tempState;
    $[117] = t43;
  } else {
    t43 = $[117];
  }
  let t44;
  if ($[118] !== errors || $[119] !== tab || $[120] !== tempState.thankYouPage) {
    t44 = tab === PhysicalProductTabEnum.thank_you && <ThankYouTab thankYouPage={tempState.thankYouPage} onChange={thankYouPage => setTempState(prev_0 => ({
      ...prev_0,
      thankYouPage
    }))} errors={errors} />;
    $[118] = errors;
    $[119] = tab;
    $[120] = tempState.thankYouPage;
    $[121] = t44;
  } else {
    t44 = $[121];
  }
  let t45;
  if ($[122] !== t || $[123] !== tab || $[124] !== tempState.checkoutPage.physicalProductId) {
    t45 = tab === PhysicalProductTabEnum.physical_product && tempState.checkoutPage.physicalProductId && <PrimaryButton as={LinkWithoutPrefetch} href={`/products/${tempState.checkoutPage.physicalProductId}`} target="_blank">{t("dashboard.store.item.physical_product.edit")}</PrimaryButton>;
    $[122] = t;
    $[123] = tab;
    $[124] = tempState.checkoutPage.physicalProductId;
    $[125] = t45;
  } else {
    t45 = $[125];
  }
  const t46 = !inReadyToSave;
  const t47 = isPublishAllowed || !isCreatingProcess ? onPublish : undefined;
  let t48;
  if ($[126] !== isFetchingPublish || $[127] !== t46 || $[128] !== t47) {
    t48 = {
      disabled: t46,
      onClick: t47,
      isFetching: isFetchingPublish
    };
    $[126] = isFetchingPublish;
    $[127] = t46;
    $[128] = t47;
    $[129] = t48;
  } else {
    t48 = $[129];
  }
  const t49 = !inReadyToSave;
  let t50;
  if ($[130] !== isFetchingDraft || $[131] !== onSaveDraft || $[132] !== t49) {
    t50 = {
      disabled: t49,
      onClick: onSaveDraft,
      isFetching: isFetchingDraft
    };
    $[130] = isFetchingDraft;
    $[131] = onSaveDraft;
    $[132] = t49;
    $[133] = t50;
  } else {
    t50 = $[133];
  }
  let t51;
  if ($[134] !== isCreatingProcess || $[135] !== isPublishAllowed || $[136] !== tab) {
    t51 = isCreatingProcess && !isPublishAllowed ? () => {
      const nextTab = getNextTab(tab);
      if (nextTab) {
        setTab(nextTab);
      }
    } : undefined;
    $[134] = isCreatingProcess;
    $[135] = isPublishAllowed;
    $[136] = tab;
    $[137] = t51;
  } else {
    t51 = $[137];
  }
  let t52;
  if ($[138] !== t51) {
    t52 = {
      onClick: t51
    };
    $[138] = t51;
    $[139] = t52;
  } else {
    t52 = $[139];
  }
  let t53;
  if ($[140] !== t48 || $[141] !== t50 || $[142] !== t52) {
    t53 = <ItemActions publish={t48} saveDraft={t50} next={t52} />;
    $[140] = t48;
    $[141] = t50;
    $[142] = t52;
    $[143] = t53;
  } else {
    t53 = $[143];
  }
  let t54;
  if ($[144] !== t45 || $[145] !== t53) {
    t54 = <div className="flex justify-end gap-5">{t45}{t53}</div>;
    $[144] = t45;
    $[145] = t53;
    $[146] = t54;
  } else {
    t54 = $[146];
  }
  let t55;
  if ($[147] !== t40 || $[148] !== t41 || $[149] !== t42 || $[150] !== t43 || $[151] !== t44 || $[152] !== t54) {
    t55 = <div className={t39}>{t40}{t41}{t42}{t43}{t44}{t54}</div>;
    $[147] = t40;
    $[148] = t41;
    $[149] = t42;
    $[150] = t43;
    $[151] = t44;
    $[152] = t54;
    $[153] = t55;
  } else {
    t55 = $[153];
  }
  return t55;
};
export default Edit;